import {U, __, COMPARSION, WISHLIST, TOOLTIP, CATALOG} from './global';
import {GTM} from "./gtm";

export const FILTER = {
    ftimemout: false,
    force_change_url: false,
    ftimemoutSec: 50,
    ftimemoutId: false,
    timemout: false,
    timemoutSec: 100,
    timemoutId: false,
    waschages: false,
    pagex: 0,
    pagey: 0,
    counter: 0,
    pagex_was: 0,
    pagey_was: 0,
    obj_id: 0,
    obj_type: 0,
    more_opened: 0,
    topposition: 0,
    title_replace: true,
    url: false,
    checked: [],
    was_page: '',
    vendor: '',
    type: '',
    catalog_id: 0,
    mobile_opened: false,
    is_loading: false,
    last_filter_element: false,
    params: {},
    currentpage: 1,
    originpage: 1,
    mobile_open: 0,
    is_catalog: false,
    replace_catalog: true,
    previewmode: 'grid',
    selected_menu: 0,
    catalog_type: 0,
    force_update: 0,
    accs_relations: [],

    _is_mpc: false,

    price_timeout: false,
    price_timeoutId: false,
    price_timeoutSec: 1800,

    search_options: [],

    promotionMode: 0,
    action: 'catalog',
    pagination_started: false,
    catalog_default_sort_field: '',
    catalog_default_sort_direction: '',
    search_query: '',
    change_url: true,
    filter_replace: false,
    extend_params: {},
    extend_options: function(settings) {
        // temporary disable
        Object.assign(this, settings.filter)

        if (!(typeof catalog_promotion === "undefined"))
            this.setPromotionMode(1);
    },

    escapeAttr: function(str) {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/"/g, "&quot;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    },

    postData: async function (data = {}, url = '/aj') {
        data.action = this.getAction();
        data.locale = G.locale_id;
        data.to = this.getTo();
        data.catalog_id = this.getToId();
        data.id = this.getToId();
        data.previewmode = this.previewmode;
        data.force_update = this.force_update;
        data.page = this.currentpage;
        data.obj_id = this.obj_id;
        data.obj_type = this.obj_type;
        data.options = this.get_visible_options();
        data.opened = this.more_opened;

        Object.assign(data, this.extend_params);

        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-requested-with': 'XMLHttpRequest'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: new URLSearchParams(data)
        });
        return response.json(); // parses JSON response into native JavaScript objects
    },

    toggleMargedFilters: function() {
        $.each($(".filter__content >div .filter__details"), (i, item) => {
            item = $(item);

            let container = item.parent();

            if (container.find('.sub .filter-content .filter__item:not(.hasNo)').length==0) {
                container.find('.filter__details').addClass('permaHidden');
                container.find('.sub').addClass('permaHidden');
            } else {
                container.find('.filter__details').removeClass('permaHidden');
                container.find('.sub').removeClass('permaHidden');
            }
        });
    },

    setExtendParams: function(params) {
        this.extend_params = {...this.extend_params, ...params};
    },

    range_slider: function() {
        if ($(".slider-range").length > 0) {
            U.loadscript("/themes/js/nouislider.js", () => {
                $.each($(".slider-range"), (i, item) => {
                    let pricerange = $(item);

                    if (!(pricerange.data('min_all')==pricerange.data('max_all'))) {
                        // let ranger = document.getElementById("slider-range");

                        try {
                            noUiSlider.create(pricerange[0], {
                                start: [pricerange.data('min'), pricerange.data('max')],
                                connect: true,
                                range: {
                                    'min': pricerange.data('min_all'),
                                    'max': pricerange.data('max_all')
                                }
                            });

                            let currentValues = [];
                            currentValues[0] = pricerange.data('min');
                            currentValues[1] = pricerange.data('max');

                            pricerange[0].noUiSlider.on('update', (values, handle) => {
                                if (!(currentValues[0] == values[0] && currentValues[1] == values[1]) && !(parseInt(values[0]) == parseInt(values[1]))) {
                                    currentValues[0] = -1;
                                    currentValues[1] = -1;
                                    pricerange.parent().parent().find('[name=from]').val(parseInt(values[0]));
                                    pricerange.parent().parent().find('[name=to]').val(parseInt(values[1]));

                                    this.last_filter_element = pricerange;
                                    this.set_pricetimeout();
                                }
                            });
                        } catch(e){
                            // console.log(e);
                        }
                    }
                });
            });

        }
    },

    toggleAllContainers: function() {
        if ($(".filter__content >div").length > 0)
            $.each($(".filter__content >div"), (i, container) => {
                container = $(container);
                this.sortingContainer(container);
                if (container.find('.show-all').length > 0 || container.find('.do-short').length > 0) {
                    this.toggleContainer(container, container.find('.show-all:not(.hidden)').length > 0 ? 'close' : 'open');
                }
            });
    },

    toggleContainer: function(container, action) {
        let limit = container.data('shortcount');

        if (action=='close') {
            container.find('.show-all').removeClass('hidden');
            container.find('.hasNo').addClass('hidden');

            let counter = 1;
            let inactive_allow = limit - container.find('.filter-inner >.filter-content >a.active, .filter-inner >.filter-content >a:not(.hasNo)').length;

            $.each(container.find('.filter-inner >.filter-content >a'), function(i, item) {

                item = $(item);

                if (item.hasClass('hasNo')) {
                    if ((inactive_allow > 0 && counter <= limit) || item.hasClass('active')) {
                        inactive_allow--;
                        item.removeClass('hidden');
                        counter++;
                    } else
                        item.addClass('hidden');
                } else {
                    if (item.hasClass('active') || counter <= limit) {
                        item.removeClass('hidden');
                        counter++;
                    }
                    else
                        item.addClass('hidden');
                }
            });

            this.show_do_short(container, 'hide');
        } else {
            container.find('.filter-inner >.filter-content a.hidden').removeClass('hidden');
            container.find('.show-all').addClass('hidden');

            if (container.find('.filter-content >a:visible').length < 6) {
                container.addClass('low-results');
            } else {
                container.removeClass('low-results');
            }

            this.show_do_short(container, ((container.find('.filter-inner >.filter-content >a').length > limit) && (container.find('.filter-inner >.filter-content .do-short-container').length==0)) ? 'show' : 'hide');
        }
    },

    show_do_short: function(container, action) {
        switch(action) {
            case 'show':
                container.find('.filter-inner >.filter-content').addClass('filter-content-doshort');

                if (container.find('.do-short').length==0) {
                    container.append('<div class="do-short">' + __('Згорнути') + '</div>');
                }

                break;
            case 'hide':
                container.find('.do-short').remove();
                container.find('.filter-inner >.filter-content').removeClass('filter-content-doshort').find('.do-short').remove();
                break;
            default:
                break;
        }
    },

    sortingContainer: function(container) {
        container.find('.filter-inner >.filter-content >a').sort(
            function (a, b) {
                a = $(a);
                b = $(b);
                let _a = a.data('position');
                let _b = b.data('position');
                return +_a - +_b;
            }
        ).prependTo( container.find('.filter-inner >.filter-content') );
    },

    fill_options_search: function() {
        console.log('this.search_options', this.search_options);
        if (this.search_options.length > 0)
            this.search_options.forEach((option_values, option_id) => {

                if ($(`.filter__content >div[data-id="${option_id}"]`).length > 0) {
                    let container = $(`.filter__content >div[data-id="${option_id}"]`);

                    if (typeof option_values.settings === "boolean") {
                        if (option_values.settings) {
                            container.find('.filter-title .cog').addClass('active');
                            container.find('.filter-settings').removeClass('hidden');
                        } else {
                            container.find('.filter-title .cog').removeClass('active');
                            container.find('.filter-settings').addClass('hidden');
                        }
                    }

                    if (typeof option_values.hide_unavailable === "boolean" && option_values.hide_unavailable) {
                        container.find('>div >.filter-content').addClass('hide-anavailable');
                        container.find('.eye').addClass('active');
                        container.find('.filter-title span.counter').remove();

                        let total_values = container.find('>div >.filter-content >a').length;
                        let active_values = container.find('>div >.filter-content >a:not(.hasNo)').length;

                        container.find('.filter-title').append('<span class="counter">(&nbsp;' + active_values + '/' + total_values + '&nbsp;)</span>');
                    }
                    else {
                        container.find('>div >.filter-content').removeClass('hide-anavailable');
                        container.find('.filter-title span.counter').remove();
                        container.find('.eye').removeClass('active');
                    }

                    if (typeof option_values.query === "string" && !(option_values.query=="")) {
                        container.find('.filter-settings input').val(option_values.query);
                        container.find('.filter-settings .remove').removeClass('hidden');
                    } else
                        container.find('.filter-settings .remove').addClass('hidden');

                    option_values.sort = typeof option_values.sort === "undefined" ? "" : option_values.sort;
                    option_values.direction = typeof option_values.direction === "undefined" ? "" : option_values.direction;

                    if (!(option_values.sort=="") && !(option_values.direction=="")) {
                        container.find('.filter-settings a').removeClass('active');
                        container.find('.filter-settings a.' + option_values.sort).addClass('active ' + option_values.sort + '_' + option_values.direction).removeClass(option_values.sort + '_' + (option_values.direction=='asc'?'desc':'asc'));
                    }

                    if (typeof option_values.expand === "boolean" && option_values.expand) {
                        container.find('.show-all').trigger('click');
                    }

                    this.do_option_filter(container.find('>div >.filter-content'), option_values);
                }

            });
    },

    set_option_search: function(option_id, params) {
        if (!(typeof this.search_options[option_id]==="object"))
            this.search_options[option_id] = {};

        $.extend(this.search_options[option_id], params);
    },

    do_option_filter: function(container, params) {

        let query = typeof params.query === "undefined" ? "" : params.query;

        container.parent().parent().removeClass('low-results');

        if (!(query=='')) {
            if (container.find('>a').length) {

                $.each(container.find('>a'), function (i, item) {
                    item = $(item);
                    if (item.text().toLowerCase().indexOf(query.toLowerCase()) !== -1)
                        item.removeClass('hidden');
                    else
                        item.addClass('hidden');
                });

            }

        } else {
            if (typeof params.expand === "boolean" && params.expand) {
                container.find('a').removeClass('hidden');
            }
        }

        params.sort = typeof params.sort === "undefined" ? "" : params.sort;
        params.direction = typeof params.direction === "undefined" ? "" : params.direction;

        if (!(params.sort=="") && !(params.direction==""))
            this.sort_values(container, params.sort, params.direction);

        if (container.find('>a:visible').length < 6) {
            container.parent().parent().addClass('low-results');
        }
    },

    sort_values: function(list, sorting, direction) {
        let listitems = [],
            zero = [];

        if (list.children('a').length) {
            $.each(list.children('a'), function(i, _item) {
                let item = $(_item);
                if (!item.hasClass('hasNo'))
                    listitems.push(item);
                else
                    zero.push(item);
            });

            if (listitems.length > 0)
                listitems.sort((a, b) => {
                    if (sorting == 'az') {
                        a = a.clone();
                        b = b.clone();
                        a.find('span').remove();
                        b.find('span').remove();
                        let val_a = $.trim(a.text());
                        let val_b = $.trim(b.text());
                        return val_a.toUpperCase().localeCompare(val_b.toUpperCase()) * (direction == 'asc' ? 1 : -1);
                    }
                    else {
                        return a.find('span').text().replace('+', '').toUpperCase().localeCompare(b.find('span').text().replace('+', '').toUpperCase(), 'en-US', {numeric: "true"}) * (direction == 'asc' ? 1 : -1);
                    }
                });
        }
        list.empty();

        if (listitems.length > 0)
            $.each(listitems, function(idx, itm) {
                list.append(itm.clone());
            });

        if (zero.length > 0)
            $.each(zero, function(idx, itm) { list.append(itm); });
    },

    appendProduct: function(value) {
        let credit = '';
        let target = this.is_mpc() ? `target="_blank"` : ``;

        if (value.type=='product' || typeof value.type === "undefined") {

            if (value.price <= 0)
                value.credit = '';

            if (!(value.credit == ''))
                credit = '<div class="loop__pm">' + value.credit + '</div>';

            let title_class = '';

            if (value.title.length > 52)
                title_class = 'small';

            if (G.channel==7) {
                $('<div class="loop">' +
                    '<div class="loop__container">' +
                    '<div class="loop__top">' +

                    '<div class="stickers stickers-loop">' + value.sales + '</div>' +

                    '<a class="loop__image for-impressions" href="' + value.link + '" data-name="' + value.name + '" data-sku="' + value.sku + '" data-price="' + (value.price ? value.priceclear : '') + '" data-brand="' + value.brand + '" data-category="' + value.category + '" data-position="' + value.position + '" data-images="' + value.images + '" data-variant="' + value.variant + '" data-list="' + value.list + '" data-listname="' + value.listname + '">' + value.image + '</a>' +

                    '</div>' +


                    '<a href="' + value.link + '" class="loop__title ' + title_class + ' for-impressions" data-name="' + value.name + '" data-sku="' + value.sku + '" data-price="' + (value.price ? value.priceclear : '') + '" data-brand="' + value.brand + '" data-category="' + value.category + '" data-position="' + value.position + '" data-variant="' + value.variant + '" data-list="' + value.list + '" data-listname="' + value.listname + '" title="' + FILTER.escapeAttr(value.title) + '">' + value.title + '</a>' +
                    credit +

                    '<div class="loop__pb">' +
                    value.price_output +
                    (value.basket ? value.basket : '') +
                    '</div>' +

                    '<div class="loop__extra"><div><div class="loop__hr hiddenMobile"></div>' + value.configurator + '</div></div>' +

                    '</div>' +
                    '</div>').appendTo(".catalog__goods .looplist");
            } else {
                let extra = (this.is_outlet() ? '<div class="loop__outlettext"><strong>' + __('Уцінка') + '!</strong> ' + value.comment + '</div>' : '') +
                    (value.configurator!='' ? '<span class="loop__config">' + value.configurator + '</span>' : '') +
                    value.stickers2 +
                    (value.price && value.opened!='0' ? '<div class="loop__last">Останній в наявності</div>' : '') +
                    (value.stickers_bottom ? '<div class="stickers stickers-loop-bottom">' + value.stickers_bottom + '</div>' : '');

                extra = $.trim(extra);

                // value.colors +
                $('<div class="loop">' +
                    '<div class="loop__container">' +
                    '<div class="loop__dots mobileVisible"></div>' +

                    '<div class="loop__ri">' +
                    '<a href="javascript: void(null);" class="ri ri-wishlist hover-tooltip" data-context="' + value.context_id + '" data-target=".ri__wishlisthover" data-place="bottom" data-subclass="tooltip-wishlist" data-sku="' + value.sku + '"></a>' +
                    '<a href="javascript: void(null);" class="ri ri-compare hover-tooltip" data-context="' + value.context_id + '" data-target=".ri__wishlisthover" data-place="bottom" data-subclass="tooltip-wishlist" data-sku="' + value.sku + '"></a>' +
                    '</div>' +

                    '<div class="stickers stickers-loop">' + value.sales + '</div>' +

                    '<a class="loop__image for-impressions" ' + target + ' href="' + value.link + '" data-name="' + value.name + '" data-sku="' + value.sku + '" data-price="' + (value.price ? value.priceclear : '') + '" data-brand="' + value.brand + '" data-category="' + value.category + '" data-position="' + value.position + '" data-images="' + value.images + '" data-variant="' + value.variant + '" data-list="' + value.list + '" data-listname="' + value.listname + '">' + value.image + '</a>' +

                    credit +

                    '<a href="' + value.link + '" ' + target + ' class="loop__title ' + title_class + ' for-impressions" data-name="' + value.name + '" data-sku="' + value.sku + '" data-price="' + (value.price ? value.priceclear : '') + '" data-brand="' + value.brand + '" data-category="' + value.category + '" data-position="' + value.position + '" data-variant="' + value.variant + '" data-list="' + value.list + '" data-listname="' + value.listname + '" title="' + FILTER.escapeAttr(value.title) + '">' + value.title + '</a>' +

                    '<div class="loop__rb">' +
                        value.rating +
                        (typeof value.cashback === "undefined" ? '' : value.cashback) +
                    '</div>' +

                    '<div class="clearfix"></div>' +

                    value.promo_message +
                    '<div class="loop__pb">' +
                    value.price_output +
                    (value.basket ? value.basket : '') +
                    '</div>' +
                    `${this.is_outlet() ? `` : `<div class="loop__avholder">${value.av}</div>`}` +
                    (extra!='' ? `<div class="loop__extra"><div><div class="loop__hr hiddenMobile"></div>${extra}</div></div>` : '') +

                        '</div>' +
                    '</div>').appendTo(".catalog__goods .looplist");
            }
        } else if (value.type=='promo') {
            $('<div class="loop loop-promo">' + value.html + '</div>').appendTo(".catalog__goods .looplist");
        } else if (value.type=='outlet') {
            console.log(123);
            $(value.html).appendTo(".catalog__goods .looplist");
        }
    },

    appendPCList: function(value) {
        if (value.type=='product') {

            if (value.price <= 0) {
                value.credit = '';
            }

            $(`
                <div class="loopw">
                    <a class="loop__image loopw__image for-impressions" href="${value.link}" data-name="${value.name}" data-sku="${value.sku}" data-price="${value.price ? value.priceclear : ''}" data-brand="${value.brand}" data-category="${value.category}" data-position="${value.position}" data-images="${value.images}" data-variant="${value.variant}" data-list="${value.list}" data-listname="${value.listname}">${value.image}</a>
                    <div class="loopw__mid">
                        ${value.sales!='' ? `<div class="stickers stickers-loop">${value.sales}</div>` : ``}
                        <a href="${value.link}" class="loop__title for-impressions" data-name="${value.name}" data-sku="${value.sku}" data-price="${value.price ? value.priceclear : ''}" data-brand="${value.brand}" data-category="${value.category}" data-position="${value.position}" data-variant="${value.variant}" data-list="${value.list}" data-listname="${value.listname}">${value.title}</a>
                        ${value.optionslist??``}
                        <a href="${value.link}" class="typical typical-chevron-down js-loopw__details" target="_blank">Детальніше</a>
                    </div>
                    <div class="loopw__price">
                        ${value.credit == '' ? `` : `${value.credit}`}
                        ${value.price_output}
                    </div>
                    <div class="loopw__buy">
                        ${value.basket ? value.basket : ''}
                    </div>
                    <div class="loopw__options mobileVisible">
                        ${value.optionslist??``}
                        <a href="${value.link}" class="typical typical-chevron-down js-loopw__details" target="_blank">Детальніше</a>
                    </div>
                </div>
                <div class="loopw__details hidden">${value.big_optionslist}</div>
            `).appendTo(".catalog__goods .looplist-pc");
        }
    },

    randomInt: function(min, max) {
        return min + Math.floor((max - min) * Math.random());
    },

    insertPromoLoop: function() {
        let result = false;

        if (G.channel==1) {
            let html = '<li class="loop promo"><div class="loop__title">' + __('Шукаєте<br /><strong>вигідні<br />пропозиції?') + '</strong></div>\n' +
                '<div class="loop__description">' + __('Підпишіться на розсилку, та отримайте їх першим') + '</div>\n' +
                '<a href="#" class="open-subscribe-chat" data-to="catalog">' + __('Підписатися') + '</a></li>';

            $(".loop.promo").remove();

            let count = $(".loop").length;

            if (count > 0) {
                let limit = 48;
                let off = count > 48 ? count - limit : 0;

                let row = this.randomInt(0, (limit/4));
                let col = this.randomInt(2, 4);
                let pos = row * 4 + col - 1;

                $.each($(".loop"), function(i, item){
                    if (i==pos) {
                        $(html).insertBefore($(item));
                        result = true;
                        GTM.event('subscribe_catalog', 'catalog');
                    }
                });
            }
        }

        return result;
    },

    appendProductList: function(value) {
        if (value.type=='outlet') {
            $(value.html).appendTo(".catalog__goods .looplist");
        } else {
            let title_class = '';

            if (value.title.length > 52)
                title_class = 'loop__title-small';

            let bottom = '<div class="loop__bottom">' + value.price_output + value.basket + '<div class="loop__delivery_date ' + (value.available == 'В наявності' ? 'carless' : '') + '" title="Наявність">' + value.available + '</div></div>';

            if (typeof value.bottom === "string" && value.bottom != '')
                bottom = value.bottom;

            $('<div class="loop list loop-list">' +
                '<div class="loop__ri loop__ri-list">' +
                '   <a href="javascript: void(null);" class="ri ri-wishlist hover-tooltip" data-target=".ri__wishlisthover" data-place="bottom" data-subclass="tooltip-wishlist" data-sku="' + value.sku + '"></a>' +
                '   <a href="javascript: void(null);" class="ri ri-compare hover-tooltip" data-target=".ri__comparehover" data-place="bottom" data-subclass="tooltip-compare" data-sku="' + value.sku + '"></a>' +
                '</div>' +
                '<div class="stickers stickers-loop stickers-loop-list">' + value.sales + '</div>' +
                '<a class="loop__image for-impressions" href="' + value.link + '" data-name="' + value.name + '" data-sku="' + value.sku + '" data-price="' + (value.price ? value.priceclear : '') + '" data-brand="' + value.brand + '" data-category="' + value.category + '" data-position="' + value.position + '" data-images="' + value.images + '" data-variant="' + value.variant + '" data-list="' + value.list + '" data-listname="' + value.listname + '">' + value.image + '</a>' +
                '<a href="' + value.link + '" class="loop__title ' + title_class + ' for-impressions" data-name="' + value.name + '" data-sku="' + value.sku + '" data-price="' + (value.price ? value.priceclear : '') + '" data-brand="' + value.brand + '" data-category="' + value.category + '" data-position="' + value.position + '" data-variant="' + value.variant + '" data-list="' + value.list + '"  data-listname="' + value.listname + '">' + value.title + '</a>' +
                value.looplistpart +
                bottom +
                '</div>').appendTo(".catalog__goods .looplist");
        }
    },

    set_pricetimeout: function() {
        if (this.price_timeout)
            clearTimeout(this.price_timeoutId);

        this.price_timeoutId = setTimeout(function(){
            $(".filter__go").trigger('click');
        }, this.price_timeoutSec);
        this.price_timeout = true;
    },

    is_mobile: function() {
        return $( window ).width() >= 768 ? false : true;
    },

    setpage: function(currentpage){
        this.currentpage = currentpage;
    },

    setoriginpage: function(currentpage){
        this.originpage = currentpage;
    },

    setPromotionMode: function(mode){
        this.promotionMode = mode;
    },

    setgetparam: function(key, value){
        this.params[key] = value;
    },

    gotry: function(){

        if (this.is_loading) {
            return false;
        }

        clearTimeout(this.ftimemoutId);
        this.pagex_was = this.pagex;
        this.pagey_was = this.pagey;

        if (this.is_mobile()) {
            $(".filter__applybtn").addClass('loading').html(__('Завантаження'));
        }

        this.setoriginpage(1);

        this.ftimemoutId = setTimeout(() => {
            this.gotrys();
        }, this.ftimemoutSec);

        this.ftimemout = true;

    },

    removeAll: function(){
        $.each($(".filter-content >label, .filter-content >a"), (index, checkbox) => {
            checkbox = $(checkbox)

            if (checkbox.hasClass('active') && (checkbox.data('name')=='brand' || checkbox.data('name')=='type')) {
                this.force_update = 1;
            }

            checkbox.removeClass('active');

        });

        $(".filter-content [name=from], .filter-content [name=to]").val('');

        if (!this.promotionMode)
            G.promo_id = 0;

        this.gotry();
    },

    gotrys: function(){

        if (this.is_loading)
            return false;

        if (Math.abs(this.pagex - this.pagex_was) < 10 && Math.abs(this.pagey - this.pagey_was) < 10) {
            this.load(1);
        } else {
            clearTimeout(this.timemoutId);

            console.log('timeout');
            this.timemoutId = setTimeout(() => {
                this.load(1);
            }, this.timemoutSec);
            this.timemout = true;
        }
    },
    
    is_search: function() {
        return this.catalog_id==3 ? true : false;
    },

    is_outlet: function() {
        return this.catalog_id==5 ? true : false;
    },

    is_slr_focus: function() {
        return this.catalog_id==4 ? true : false;
    },

    is_promotion: function() {
        return this.promotionMode ? true : false;
    },

    is_accs: function() {
        return ($(".filter").parents('.product__accscontent').length > 0 || $(".filter").parents('.makepc__outer').length > 0);
    },

    is_mpc: function() {
        return this._is_mpc;
    },

    change_url_allowed: function() {
        return this.change_url;
    },

    load_promotions: function(promotions) {
        if (promotions.length!=0) {
            let current = $(".headerCatelog .stockBlock");

            if ($(".headerCatelog .stockBlock").length!=0) {
                let need = 0;

                $.each(promotions, function(index, promotion){
                    if (promotion.id == current.data('promotion_id'))
                        need = index + 1;
                });

                let promo = (promotions.length < (need + 1)) ? promotions[0] : promotions[need];
                current.data('promotion_id', promo.id).attr('href', promo.url).find('p').html('<span class="text-uppercase">'+__('АКЦІЯ!')+'</span> '+promo.title);
            }
        }
    },

    hide_empty_filters: function(){
        $.each($(".filter__content >div:not(.filter__tgl)"), function(index, value){

            if (!($(this).data('id')==100)) {
                if ($(this).find('.filter-content >a, .filter-content >label').length == $(this).find('.btn.hasNo').length && $(this).find('.filter-content >a, .filter-content >label').length > 0) {
                    $(this).addClass('hidden');
                    console.log('hidden filter1', $(this).data('id'));
                } else {
                    $(this).removeClass('hidden');
                }
            }
        });

        $.each($(".filter__content >div:not(.filter__tgl)"), function(index, value){
            value = $(value);

            if (!(value.data('id')==100)) {
                if (value.find('.filter-content >a, .filter-content >label').length > 0)
                    if (value.find('.filter-content >a, .filter-content >label').length == value.find('.filter-content .hasNo:not(.active)').length) {
                        value.addClass('hidden');
                        console.log('hidden filter2', value.data('id'), value.html());
                    }
                    else
                        value.removeClass('hidden');
                else {
                    value.addClass('hidden');
                    console.log('hidden filter3', value.data('id'));
                }
            }
        });

    },

    get_visible_options: function() {
        let options = [];

        $.each($(".filter__content >div"), function(index, div){
            div = $(div);

            if (div.is(':visible'))
                options.push(div.data('id'))
        });

        return options.join(',');
    },

    hideBrandText: function(){

        if ($(".brand .btnMore").length && $(".brand .btnMore").hasClass('hidden')) {
            $(".brand .btnMore").trigger('click');
        }

        return;
    },

    getAction: function() {
        return this.promotionMode ? 'promo' : (this.is_outlet() ? 'outlet' : (this.is_slr_focus() ? 'slrf' : this.action));
    },

    getTo: function() {
        return this.promotionMode ? 'index' : 'filter';
    },

    getToId: function() {
        return this.promotionMode ? G.promo_id : this.catalog_id;
    },

    show_more_btn: function(data) {
        // Pagination
        if (data.show_more_text != '') {
            $(".catalog__goods .show-more").html(data.show_more_text).removeClass('hidden');
            console.log('show-more', data.show_more_text);
        }
        else {
            $(".catalog__goods .show-more").addClass('hidden');
        }
    },

    load: function(ajax, url_added){
        return new Promise((resolve, reject) => {
            this.hideBrandText();
            this.setpage(1);
            let url = (typeof url_added == 'string') ? url_added : this.make_url();

            this.was_page = url;
            this.counter++;

            this.setpage(1);

            if (ajax) {
                if (this.is_search() || this.is_accs() || this.is_outlet() || this.is_mpc())
                    this.force_update = 1;

                $(".filter__scroll").addClass('loading');
                $(".js-looplist").addClass('js-looplist-loading');

                this.postData(
                    {string: url},
                    '/aj?' + url
                ).then((data) => {
                    if (url!==this.make_url() && typeof url_added !== 'string') {
                        if (this.change_url_allowed()) {
                            history.pushState({}, null, url);
                            GTM.event('pageview', url);
                        }

                        this.load(ajax);
                    }
                    else {

                        let was_seo = false;

                        if (typeof url_added !== 'string' && this.change_url_allowed()) {
                            history.pushState({}, null, url);
                            GTM.event('pageview', url);
                        }

                        if (this.title_replace && !(data.documenttitle === undefined)) {
                            document.title = data.documenttitle;
                        }

                        if (!this.is_promotion()) {

                            if ($(".seo-link").length)
                                was_seo = true;

                            $(".catalog__title h1").html(data.title);
                            $(".catalog__count").html(data.goods_count);

                            if (was_seo)
                                $(".catalog .container__title h1").append('<a href="#" class="seo-link"></a>');
                        }

                        $(".catalog__title h1").html(data.title);
                        $(".catalog__count").html(data.goods_count);

                        if (was_seo)
                            $(".catalog__title h1").append('<a href="#" class="seo-link"></a>');

                        if (this.force_update) {
                            this.last_filter_element
                            let openedfilters = [];
                            let expanded_filters = [];
                            let wasfilters = [];
                            let replacedata = $(data.html);
                            let openedparents = [];
                            let last_filter_option_id = 0;
                            let last_filter_value = '';

                            if (this.last_filter_element) {
                                last_filter_option_id = this.last_filter_element.data('option_id');
                                last_filter_value = this.last_filter_element.data('value');
                            }

                            // opened
                            $.each($(".filter__content >div:not(.filter__tgl)"), function(i, fil) {
                                fil = $(fil);
                                let filter_id = fil.find('.filter-content >label, .filter-content >a').data('option_id');

                                if (!filter_id)
                                    filter_id = fil.data('id');

                                wasfilters.push(filter_id);

                                if (fil.find('.show-all').hasClass('hidden'))
                                    expanded_filters.push(filter_id);

                                if (fil.hasClass('isChild')) {
                                    if (!fil.hasClass('hidden'))
                                        openedfilters.push(filter_id);
                                } else {
                                    if (fil.find('.filter-title').hasClass('opened'))
                                        openedfilters.push(filter_id);

                                    if (fil.hasClass('isParent'))
                                        if (fil.find('.filter__details').hasClass('active'))
                                            openedparents.push(filter_id);
                                }
                            });

                            // filter replace
                            if (this.filter_replace) {
                                $(".catalog__filter").remove();
                                $(".catalog").append(data.html);

                                if (U.isMobile() && FILTER.mobile_opened) {
                                    $('.filter').addClass('show');
                                    $("body").addClass('body-filter-show');
                                }
                            }

                            if (U.isMobile()) {
                                if (replacedata.find('.filter__content >div:not(.filter__tgl)').length)
                                    $.each(replacedata.find('.filter__content >div:not(.filter__tgl)'), function(i, item){
                                        item = $(item);

                                        if (!(jQuery.inArray( item.data('id'), wasfilters ) >= 0)) {
                                            item.appendTo($(".filter__content"));
                                            item.addClass('was-added');
                                        }
                                    });
                            } else {
                                $(".filter__content").html(replacedata.find('.filter__content').html());

                                $.each($(".filter__content >div:not(.filter__tgl)"), (i, item) => {
                                    item = $(item);

                                    if (item.data('id')) {
                                        if (!(jQuery.inArray(item.data('id'), wasfilters) >= 0))
                                            item.addClass('was-added');

                                        if (jQuery.inArray(item.data('id'), expanded_filters) >= 0) {
                                            item.find('.show-all').addClass('hidden');
                                            item.find('.filter-content >.hidden[data-type=checkbox], .filter-content >.hidden[data-type=radio]').removeClass('hidden');

                                            this.show_do_short(item, (item.find('.filter-inner >.filter-content .do-short-container').length==0) ? 'show' : 'hide');

                                        } else {
                                            item.find('.show-all').removeClass('hidden');
                                        }
                                    }
                                });
                            }

                            this.force_update = 0;

                            $.each($(".filter__content >div:not(.filter__tgl)"), function(i, fil) {
                                fil = $(fil);
                                let filter_id = fil.find('.filter-content >label, .filter-content >a').data('option_id');

                                if (fil.hasClass('isChild')) {
                                    if (jQuery.inArray( fil.data('parent'), openedparents ) >= 0) {
                                        if (fil.find('.filter-title').next().find('>label:not(.hasNo), >a:not(.hasNo)').length > 0) {
                                            fil.find('.filter-title').next().css('display', 'block');
                                            fil.removeClass('hidden');
                                        }
                                    }
                                } else {
                                    if (jQuery.inArray( filter_id, openedfilters ) >= 0) {
                                        fil.find('.filter-title').addClass('opened');
                                        fil.find('.filter-title').next().css('display', 'block');
                                    } else {
                                        if (jQuery.inArray( filter_id, wasfilters ) >= 0 || U.isMobile()) {
                                            fil.find('.filter-title').next().css('display', 'none');
                                            fil.find('.filter-title').removeClass('opened');
                                        }
                                    }
                                }

                                if (jQuery.inArray( filter_id, openedparents ) >= 0)
                                    fil.find('.filter__details').addClass('active');
                            });

                            this.range_slider();

                            if (last_filter_option_id && last_filter_value && $(`a[data-option_id="${last_filter_option_id}"][data-value="${last_filter_value}"]`).length > 0) {
                                this.last_filter_element = $(`a[data-option_id="${last_filter_option_id}"][data-value="${last_filter_value}"]`);
                            }
                        }

                        // Товары
                        if (this.replace_catalog || this.is_promotion()) {

                            data.template = data.template || 'default';

                            // console.log('re', this.replace_catalog, data.template);

                            if (data.template=='default') {
                                $(".catalog__goods .js-looplist").empty();

                                if ($(".catalog__goods .blocks-content").length > 0) {
                                    $(".catalog__goods .blocks-content, .catalog__goods >.looplist, .catalog__goods >.show-more, .catalog__goods >.pagination").remove();
                                    $(".catalog__goods").append(`<div class="looplist looplist-4 js-looplist ${this.previewmode=='list' ? 'looplist-list' : ''} clearfix"></div>
                                        <a href="javascript: void(null);" class="show-more">Показати ще 48 моделей</a>${data.pagination}`);
                                }

                                if (typeof data.goods == 'object' && data.goods.length > 0) {
                                    $.each(data.goods, (index, value) => {
                                        if (this.previewmode == 'grid') {
                                            this.appendProduct(value);
                                        } else if (this.previewmode == 'list') {
                                            this.appendProductList(value);
                                        } else if (this.previewmode == 'pclist') {
                                            this.appendPCList(value);
                                        }
                                    });
                                }
                            } else if (data.template=='blocks') {
                                $(".catalog__goods").empty().html(data.blocks_result);
                            }

                            GTM.event('impressions');
                            COMPARSION.update_anchors();
                            WISHLIST.update_anchors();
                        }

                        this.replace_catalog = true;

                        this.show_more_btn(data);


                        $(".pagination").remove();
                        $(data.pagination).appendTo(".catalog__goods");
                        // Filters line
                        if (data.filters_line !== '')
                            $(".selectedfilters").removeClass('hidden').empty().html(data.filters_line + '<a href="#" class="selectedfilters__remove">' + __('Очистити&nbsp;фільтри') + '</a>');
                        else
                            $(".selectedfilters").addClass('hidden');

                        if (this.is_promotion() && data.template=='blocks')
                            $(".selectedfilters").removeClass('hidden').empty().html(data.filters_line + '<a href="#" class="selectedfilters__remove">' + __('Очистити&nbsp;фільтри') + '</a>');

                        // Filters
                        $.each($(".filter-content >a >span, .filter-content >label >span"), function (index, filter) {
                            $(filter).html('');
                            $(filter).parent().addClass('hasNo').attr('rel', 'nofollow').attr('href', '#');

                            if ($(filter).parent().hasClass('active'))
                                $(filter).html('0');

                            $(filter).parent().removeClass('active');
                        });

                        $.each(data.filter, function (index, filter) {
                            if (typeof filter.items == 'object')
                                $.each(filter.items, function (i, item) {
                                    if (typeof item == 'object')
                                        $.each($(`.filter-content >[data-name="${item.name}"]`), function (is, variable) {
                                            if ($(variable).data('value') == item.value) {
                                                if (item.count > 0) {
                                                    $(variable).removeClass('hasNo').removeClass('hidden').attr('rel', '');
                                                    $(variable).find('span').html((item.name != 'stores' && item.name != 'cities') ? item.plus + item.count : '');
                                                    $(variable).attr('href', item.url);
                                                }
                                                $(variable).attr('title', item.alt);
                                            }
                                        });
                                });
                        });

                        // Set checked
                        if (typeof data.checked == 'object')
                            $.each(data.checked, function (option_name, values) {
                                if (!(typeof values === "string"))
                                    $.each(values, function (is, value) {
                                        $(`.filter-content >[data-name="${option_name}"][data-value="${value}"]`).addClass('active');
                                    });
                            });

                        this.hide_empty_filters();
                        this.load_promotions(data.promotions);

                        // Min Max
                        if (typeof data.min == 'object')
                            $.each(data.min, function (option_name, value) {
                                $(`[name=from][data-field="${option_name}"]`).attr("placeholder", value);
                            });
                        if (typeof data.max == 'object')
                            $.each(data.max, function (option_name, value) {
                                $(`[name=to][data-field="${option_name}"]`).attr("placeholder", value);
                            });

                        // toggle Детальніше
                        this.toggleMargedFilters();

                        // filter-howmuch
                        if (!this.is_mobile() && this.last_filter_element) {
                            let top = (this.last_filter_element.offset().top - 17);
                            let left = $(".filter").offset().left + $(".filter").outerWidth() + 20;

                            if ($(document).scrollTop() > 200) {
                                $(".filter-howmuch").remove();

                                let howmuch = $('<div class="filter-howmuch"></div>');

                                howmuch.html(`<span></span>${data.countname}`).css({
                                    'top': top,
                                    'left': left,
                                    'opacity': 0
                                });

                                howmuch.appendTo('body');

                                if ($(".filter").parents('.catalog-filterright').length > 0) {
                                    $(".filter-howmuch").addClass('filter-howmuch-right');
                                    left = $(".filter").offset().left - $(".filter-howmuch").outerWidth() - 10;
                                    $(".filter-howmuch").css({
                                        'left': left
                                    });

                                    left = $(".filter").offset().left - $(".filter-howmuch").outerWidth() - 10;
                                    $(".filter-howmuch").css({
                                        'left': left
                                    });
                                }

                                howmuch.fadeTo( "fast", 1 );

                                setTimeout(() => {
                                    howmuch.fadeTo( "fast", 0, () => {
                                        howmuch.remove();
                                    });
                                }, 3000);
                            }

                            // if (this.is_promotion() && this.last_filter_element && (top - 150) > 300)
                            //     $("html, body").stop().animate({scrollTop: top - 150}, '100', 'swing');
                        }

                        $(".lang a.ua").attr('href', data.locales_url.ua);
                        $(".lang a.ru").attr('href', data.locales_url.ru);

                        if (this.is_mobile() && this.mobileopened())
                            $(".filter__applybtn").removeClass('loading').html(this.is_promotion() ? __('Показати товари') : data.countname);

                        this.mobileFooterButtons();

                        if (!(this.is_search() || this.is_outlet() || this.is_accs()) && $(".promo-list").length) {
                            $(".promo-list").replaceWith(data.catalogPromoAll);
                            U.slickCatalogPromo();
                        }
                    }
                    $(".filter__scroll, .js-looplist").removeClass('loading');

                    if (data.goods.length == 0) {
                        $(".js-looplist").addClass('looplist-empty');
                    }
                    else {
                        $(".js-looplist").removeClass('looplist-empty');
                    }

                    this.toggleAllContainers();

                    if (this.more_opened)
                        $(".filter__content .filter__more").remove();

                    this.fill_options_search();

                    // seo
                    if (data.seo) {
                        CATALOG.updateSeo(data.seo?.title, data.seo?.text);
                    }

                }).finally(() => {
                    $(".js-looplist").removeClass('js-looplist-loading');
                    resolve();
                });
            } else {
                resolve();
                document.location.assign(url);
            }
        });
    },

    make_url: function(without_sort){
        let url = this.url;
        this.checked = [];
        this.params = {};
        this.context = [];
        let divpath = ".filter-content >label, .filter-content >a";

        $.each($(divpath), (key, checkbox) => {
            let th = $(checkbox);
            if (th.hasClass('active')) {
                if (th.data('name')=='context' && (this.is_search() || this.is_outlet() || this.is_accs())) {
                    this.context.push(th.data('value'));
                    return;
                } else {
                    this.checked['_' + th.data('name')] = this.checked['_' + th.data('name')] || [];
                }

                if (th.hasClass('bool')) {}
                else {
                    if (!(typeof th.data('vendor')==="undefined"))
                        this.vendor = '_' + th.data('name');

                    if (!(typeof th.data('type_id')==="undefined"))
                        this.type = '_' + th.data('name');

                    this.checked['_' + th.data('name')].push(th.data('value'));

                }
            }
        });

        let segments = [];

        if (this.vendor!=='' && this.checked[this.vendor]) {
            let wkey = this.vendor.substring(0, 1)=='_' ? this.vendor.substring(1) : this.vendor;
            segments.push(wkey + '-' + this.checked[this.vendor].sort().join('-'));
        }

        if (G.promo_id && !this.promotionMode)
            segments.push('promo-' + G.promo_id);

        if (this.type!=='' && this.checked[this.type]) {
            let wkey = this.type.substring(0, 1)=='_' ? this.type.substring(1) : this.type;
            segments.push(wkey + '-' + this.checked[this.type].sort().join('-'));
        }

        segments = segments.join('/');
        if (segments!=='')
            url = url+segments+'/';

        segments = [];
        // console.log(this.checked);
        for(let key in this.checked) {
            let wkey = key.substring(0, 1)=='_' ? key.substring(1) : key;

            if (this.type!==key && this.vendor!==key) {
                if (this.checked[key].length) {
                    if ($(`[data-field="${wkey}"][data-fromto=1]`).length)
                        segments.push(wkey + '-' + this.checked[key].join('-'));
                    else
                        segments.push(wkey + '-' + this.checked[key].sort().join('-'));
                } else {
                    segments.push(wkey);
                }
            }
        }

        if (this.context.length > 0)
            segments.push(this.context.join('-'));

        segments = segments.sort();
        segments = segments.join('/');

        if (!(segments==''))
            url = url+segments+'/';

        if (this.currentpage > 1)
            this.setgetparam('page', this.currentpage);

        if ((this.is_search() || this.is_mpc()) && this.search_query!='')
            this.setgetparam('q', this.search_query);

        let params = $.param(this.params);

        if (this.catalog_sort && without_sort!==1 && !(this.catalog_sort=='sort-price' || this.catalog_sort=='sort-new' || this.catalog_sort==''))
            if (!(this.catalog_sort=='sort-'+this.catalog_default_sort_field+'-'+this.catalog_default_sort_direction) && !(this.catalog_sort=='sort-'+this.catalog_default_sort_field))
                if ((this.is_search() || this.is_mpc()) && !this.obj_id) {
                    params = params + '&' + this.catalog_sort;
                } else {
                    params = params.length > 0 ? this.catalog_sort : this.catalog_sort;
                }

        url = (params && params!=='') ? url + '?' + params : url;

        console.log(url, params, this.params, this.catalog_sort);

        return url;
    },

    togglemobile: function() {
        if ($('.filter').hasClass('show'))
            this.hidemobile();
        else
            this.openmobile();
    },
    
    mobileopened: function() {
        return $('.filter').hasClass('show') ? true : false;
    },

    fixscroll: function() {
        if (U.isMobile()) {


            if ($(".filter").hasClass('show')) {
                $("body, html").addClass('disablescroll');
            } else {
                if ($(".mpc__contexts-opened").length==0)
                    $("body, html").removeClass('disablescroll');
            }
        }
    },

    hidemobile: function(without) {
        let el = $(".filter");
        if (el.hasClass('show')) {

            if (this.waschages) {
                $("html, body").stop().animate({scrollTop: 123}, '200', 'swing');
                this.waschages = false;
            }

            if (without!=1 && this.change_url_allowed()) {
                history.pushState({}, null, window.location.href.split('#')[0]);
                GTM.event('pageview', window.location.href.split('#')[0]);
            }

            $('.filter-main').hide();
        }

        $(".menubg, .menubg-contain").removeClass('show');
        $("body").removeClass('body-filter-show');
        el.removeClass('show');

        if (el.parents('.mpc__filterwindow').length > 0) {
            el.parents('.mpc__filterwindow').removeClass('mpc__filterwindow-openedfilter');
        }

        this.fixscroll();
        this.mobile_opened = false;
    },

    openmobile: function(without) {
        this.waschages = false;
        let el = $(".filter");
        if (!(el.hasClass('show'))) {

            if (this.is_search()) {
                // закриваємо всі, окрім розділів (якщо їх більше 1)
                $(".filter .filter__content >div:not(.option-2) .filter-title").removeClass('opened').next().css('display', 'none');
                $(".filter .filter__content >div.option-2 .filter-title").addClass('opened').next().css('display', 'block');
            } else {
                // закрываем все фильтры
                $(".filter .filter-title").removeClass('opened');
                $(".filter .filter-title").next().css('display', 'none');
            }

            let url = window.location.href.split('#')[0];
            url = url + '#filter';

            if (without!=1 && this.change_url_allowed()) {
                history.pushState({}, null, url);
                GTM.event('pageview', window.location.href.split('#')[0]);
            }

            this.mobileFooterButtons();
            el.addClass('show');
            $('body').addClass('body-filter-show');
            $(".menubg, .menubg-contain").addClass('show');

            if (el.parents('.mpc__filterwindow').length > 0) {
                el.parents('.mpc__filterwindow').addClass('mpc__filterwindow-openedfilter');
            }

            this.fixscroll();
            this.mobile_opened = true;
        }
    },

    setpreviewmode: function(mode) {
        if (G.is_b2b) {
            $.cookie("previewmode", mode, {
                path    : '/'
            });
            document.location.reload();
        } else {
            this.previewmode = mode;
            $(".js-looplist").empty();

            switch(this.previewmode) {
                case 'pclist':
                    $(".js-looplist").removeClass('looplist looplist-4').addClass('looplist-pc');
                    break

                case 'grid':
                    $(".js-looplist").removeClass('looplist-pc').addClass('looplist looplist-4');
                    break

                default:
                    break;
            }

            $(".show-more").addClass('hidden');
            $(".js-looplist").addClass('loading')
            this.load(true);
        }
    },

    mobileFooterButtons: function() {
        $(".filter .filter-title small").remove();

        let total_active = 0;

        if ($(".filter__content >div").length)
            $.each($(".filter__content >div"), function(i, item){
                item = $(item);

                let active_count = item.find('.filter-content a.active').length;

                if (active_count) {
                    item.find('.filter-title').append('<small>' + active_count + '</small>');
                    total_active++;
                }
            });

        if (total_active) {
            total_active = total_active.toString();
            let suffix = __('фільтрів');

            if (total_active.substr(-1,1)=='1')
                suffix = __('фільтр');

            if (total_active.substr(-1,1)=='2' || total_active.substr(-1,1)=='3' || total_active.substr(-1,1)=='4')
                suffix = __('фільтри');

            $(".filter .filter-count").html(total_active + ' ' + suffix);
            $(".filter__clean").removeClass('hidden');

            if (this.is_search() && $(".filter .filter__content >div.option-2").length > 0) {
                total_active = $(".filter .filter__content >div.option-2 .filter-content .filter__item").length;
            }

            $(".filter__toggle span").removeClass('hidden').html(total_active);

            $(".filter").removeClass('empty');
        } else {
            $(".filter .filter-count").empty();
            $(".filter__clean").addClass('hidden');
            $(".filter__toggle span").empty().addClass('hidden');
            $(".filter").addClass('empty');
        }
    }

};

export function init_FILTER_events() {
    jQuery(document).ready(function () {

        if ($(".slider-range").length > 0) {
            FILTER.range_slider();
        }

        jQuery('body').on('click touchend', '.toogle-filter-promotion', function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.remove();
            G.promo_id = 0;

            FILTER.gotry();
        });

        jQuery('body').on('touch touchstart touchend', '.slider-range >span', function (e) {
            //console.log($(this));
        });

        if (!(typeof G.filter === "undefined")) {
            FILTER.extend_options(G);
        }

        $(document).mousemove(function (e) {
            FILTER.pagex = e.pageX;
            FILTER.pagey = e.pageY;
        });

        if (FILTER.is_search()) {
            GTM.event('search', G.filter.search_query);

            // eye for vendor
            FILTER.set_option_search(1, {
                hide_unavailable: true,
                settings: true
            });

            FILTER.fill_options_search();
        }

        // Вид
        jQuery("body").on("click", ".sortingBlock .view a", function (e) {
            e.preventDefault();
            FILTER.setpreviewmode($(this).data('mode'));
        });

        // Убрать фильтры (моб)
        jQuery("body").on("click", ".filter__clean", function (e) {
            e.preventDefault();
            FILTER.removeAll();
        });

        // Убрать фильтры (моб)
        jQuery("body").on("click", ".filter__searchbtn", function (e) {
            e.preventDefault();
            $(this).toggleClass('filter__searchbtn-active');
            $(".filter__search").toggleClass('filter__search-active');
        });

        // Показати ще 8 фільтрів
        jQuery("body").on("click", ".filter__content .filter__more", function (e) {
            $(".filter__content >div").removeClass('hide');
            $(this).addClass('loading');
            FILTER.force_update = 1;
            FILTER.more_opened = 1;
            FILTER.replace_catalog = false;
            FILTER.load(1);
        });

        // Поиск в детальніше
        jQuery("body").on("keyup", ".filter .sub input", function (e) {
            var input = $(this);

            if ($.trim(input.val()) == '') {
                input.next().find('a').removeClass('hidden');
            } else {
                var reg = new RegExp(input.val(), 'gi');
                if (input.next().find('a').length)
                    $.each(input.next().find('a'), function (i, item) {
                        item = $(item);

                        var text = item.html();
                        // text.find('span').remove();

                        if (!text.match(reg))
                            item.addClass('hidden');
                    });
            }
        });

        // Клик в фильтре
        jQuery("body").on("click", ".filter-content >label, .filter-content >a", function (e) {
            let btn = $(this);

            if (btn.hasClass('link'))
                return true;

            e.preventDefault();

            let val = btn.data('value');

            if (btn.hasClass('hasNo') && !btn.hasClass('active'))
                return false;

            // Ви переглядали
            if (btn.hasClass('active')) {
                btn.removeClass('active');
            } else {
                btn.addClass('active');
            }

            let field = btn.data('name');
            let option_id = btn.data('option_id');

            if (option_id == FILTER.catalog_type || option_id == 1)
                FILTER.force_update = 1;

            if (field == 'context' && (FILTER.is_search() || FILTER.is_outlet() || FILTER.is_accs())) {
                // Это только на странице поиска
                $.each($(".filter [data-name=context]"), function (index, checkbox) {
                    checkbox = $(checkbox);

                    if (!(checkbox.data('value') == val))
                        checkbox.removeClass('active');
                });

                $.each($(".filter [data-type=checkbox]").not('[data-name=context]').not('[data-name=brand]').not('[data-name=price]'), function (index, checkbox) {
                    checkbox = $(checkbox);
                    checkbox.removeClass('active');
                });
            }

            FILTER.last_filter_element = btn;

            // Чистим поле от и до
            $(".filter__content").find('[type=text][name=to]').removeClass('selected');
            $(".filter__content").find('[type=text][name=from]').removeClass('selected');
            $(".filter__content").find('[name=to]').val('');
            $(".filter__content").find('[name=from]').val('');

            FILTER.setpage(1);

            $.each($(".filter__content >div"), function (index, el) {
                if ($(".active", $(this)).length) {
                    $(".filter-title", $(this)).addClass('active');
                } else {
                    $(".filter-title", $(this)).removeClass('active');
                }
            });

            // Убиваем кликнутые значения в ценах и т.д.
            if (btn.parent().find('.eSpecial').length > 0)
                btn.parent().find('.eSpecial').remove();

            FILTER.mobileFooterButtons();
            FILTER.gotry();
            return false;
        });

        //  убрать фильтр с filterline
        jQuery("body").on("click", ".catalog .selectedfilters >*, .promo__page-filter .selectedfilters >*", function (e) {
            e.preventDefault();

            let btn = $(this);
            FILTER.setpage(1);

            if (btn.hasClass('selectedfilters__remove')) {
                FILTER.removeAll();
                return;
            }

            if (btn.hasClass('selectedfilters__removeSaved')) {
                $.post('/slr/removesavedfilter', 'to=removesavedfilter', function (result) {
                    document.location.reload();
                });
                return false;
            }

            let data = btn.data();

            if (data.option_name && !(data.option_name == 'promo'))
                $(`[name=from][data-field="${data.option_name}"], [name=to][data-field="${data.option_name}"]`).val('');

            if (data.option_name == 'type' || data.option_name == 'brand')
                FILTER.force_update = 1;

            if (FILTER.is_promotion())
                FILTER.force_update = 1;

            if (data.option_name == 'promo') {
                G.promo_id = 0;
                FILTER.force_update = 1;
            } else {
                $.each($(".filter__content [data-type=checkbox], .filter__content [data-type=radio]"), function (index, checkbox) {
                    checkbox = $(checkbox);

                    if (checkbox.data('name') == data.option_name && checkbox.data('value') == data.option_value) {
                        btn.remove();
                        checkbox.removeClass('active');
                    }
                });
            }

            FILTER.gotry();
            return false;
        });

        //  убрать фильтр с filterline (mobile)
        jQuery("body").on("click", ".filter-selected a", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let data = btn.data();

            FILTER.setpage(1);

            $(`[name=from][data-field="${data.option_name}"], [name=to][data-field="${data.option_name}"]`).val('');

            $.each($(".filter-content >a, .filter-content >label"), function (index, checkbox) {
                checkbox = $(checkbox);

                if (checkbox.data('name') == data.option_name) {
                    btn.remove();
                    checkbox.removeClass('active');
                    checkbox.parent().parent().parent().find('.filter-title').removeClass('active');
                }
            });

            if (!$(".filter-selected a").length)
                $(".filter-selected").addClass('hidden');

            FILTER.gotry();
            return false;
        });

        // Показать все означения опции
        jQuery("body").on('click', ".filter .show-all", function (e) {
            e.preventDefault();
            const btn = $(this);
            const container = btn.parents('.filter-inner').parent();
            FILTER.sortingContainer(container);
            FILTER.toggleContainer(container, 'open');
        });

        // Скрыть все означения опции
        jQuery("body").on('click', ".filter .do-short", function (e) {
            e.preventDefault();
            const btn = $(this);
            const container = btn.parent();
            FILTER.sortingContainer(container);
            FILTER.toggleContainer(container, 'close');
        });

        // открываем мобильный фильтр
        jQuery("body").on("click", ".filter__toggle", function (e) {
            e.preventDefault();
            FILTER.togglemobile();
            return false;
        });

        // открываем мобильный фильтр (сортировка)
        jQuery("body").on("click", ".filter-mobile .sort", function (e) {
            e.preventDefault();
            var btn = $(this);
            var opened = $(`.sortlist[data-for="${btn.data('for')}"]`).hasClass('opened') ? true : false;

            $(".filter-mobile .list").addClass('hidden');
            $(".filter-mobile .sortlist").removeClass('opened');
            $(".filter-mobile .sort i").removeClass('fa-angle-up').addClass('fa-angle-down');

            if (!opened) {
                $(`.sortlist[data-for="${btn.data('for')}"]`).addClass('opened');
                $(`.filter-mobile .sort[data-for="${btn.data('for')}"] i`).addClass('fa-angle-up').removeClass('fa-angle-down');
            }

            if ($(".filter-mobile .sortlist.opened").length)
                btn.parent().addClass('opened');
            else
                btn.parent().removeClass('opened');

            return false;
        });

        // закрываем моб фильтр
        jQuery("body").on("click", ".filter__close, .filter__applybtn", function (e) {
            e.preventDefault();
            FILTER.hidemobile();
            return true;
        });

        // Scroll top
        jQuery("body").on("click", ".filter-howmuch", function (e) {
            e.preventDefault();
            if ($('.mpc__context-opened .mpc__filterwindow').length > 0) {
                $('.mpc__context-opened .mpc__filterwindow').stop().animate({scrollTop: 0}, '500', 'swing');
            } else {
                $("html, body").stop().animate({scrollTop: 100}, '500', 'swing');
            }
        });

        // Изменение значения от в декстопе
        jQuery("body").on("keyup", ".filter [name=from], .filter [name=to]", function (e) {
            e.preventDefault();

            if (e.keyCode == 13) {
                clearTimeout(FILTER.price_timeoutId);
                $(".filter__go").trigger('click');
            } else
                FILTER.set_pricetimeout();
            return;
        });

        // Клик от до в мобильном
        jQuery("body").on("click", ".filter .filter__go", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);

            if (btn.hasClass('remove')) {
                btn.parent().find('[name=from]').val('');
                btn.parent().find('[name=to]').val('');
                btn.addClass('hidden');
                FILTER.last_filter_element = btn.parent().find('[name=from]');
                FILTER.gotry();
                return;
            } else {

                let from = '';
                let to = '';

                if (btn.parent().find('[name=from]').data('type') == 'float')
                    from = parseFloat(btn.parent().find('[name=from]').val());
                else
                    from = parseInt(btn.parent().find('[name=from]').val());

                from = $.isNumeric(from) ? from : 0;
                btn.parent().find('[name=from]').val(from);

                if (btn.parent().find('[name=to]').data('type') == 'float')
                    to = parseFloat(btn.parent().find('[name=to]').val());
                else
                    to = parseInt(btn.parent().find('[name=to]').val());

                to = $.isNumeric(to) ? to : 0;

                if (from > to) {
                    to = 0;
                    btn.parent().find('[name=to]').val('');
                }

                let val = from + '__' + to;

                if (!(val == '0__0')) {
                    btn.parent().find('[name=from]').addClass('selected');
                    btn.parent().find('[name=to]').addClass('selected');

                    let field = btn.parent().find('[name=from]').data('field');
                    val = (val.replace('.', '_')).replace('.', '_');


                    let title = from == 0 ? __('менше') + ' ' + to : from + ' - ' + to;
                    title = to == 0 ? __('більше') + ' ' + from : title;

                    btn.parents('.filter-inner').find('.filter-content >*').removeClass('active').find('[type=checkbox], [type=radio]').prop('checked', false);
                    btn.parents('.filter-inner').find('.filter-content .eSpecial').remove();

                    let code = '<a href="#" class="eSpecial filter__item int active" data-field="' + field + '" data-fromto="1" data-name="' + field + '" data-value="' + val + '">' +
                        ' ' + title + ' <span></span></a>';

                    btn.parents('.filter-inner').find('.filter-content:first-child').append(code);

                    FILTER.last_filter_element = btn.parent().find('>div');
                    FILTER.setpage(1);
                    FILTER.gotry();
                    btn.addClass('hidden');
                }
            }
            return;
        });

        // выбор сортировки в декстопе
        jQuery("body").on('click', ".js-sorting__item", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let new_direction = btn.data('direction');

            btn.parent().find('a').removeClass('sorting__item-active');
            btn.addClass('sorting__item-active');
            $(".sorting__selected").html(btn.text());
            TOOLTIP.hide();

            $(".sorting__choise .sorting__item").removeClass('sorting__item-active');
            $(`.sorting__choise .sorting__item[data-sort="${btn.data('sort')}"][data-direction="${btn.data('direction')}"]`).addClass('sorting__item-active');

            FILTER.last_filter_element = false;
            FILTER.catalog_sort = btn.data('sort') + (btn.data('sort') == 'sort-top' || btn.data('sort') == 'sort-search' || btn.data('sort') == 'sort-discount' ? '' : '-' + new_direction);

            FILTER.gotry();
        });

        // развернуть дочернюю характеристику
        jQuery("body").on("click", ".filter__details", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const btn = $(this);
            const items_container = btn.next();
            btn.toggleClass('active');
            items_container.toggleClass('hidden').find('.filter__item').removeClass('hidden');

            return false;
        });

        // свернуть/развернуть фильтр
        jQuery('body').on('click', '.filter-title:not(.link):not(.unclosed)', function (e) {
            e.preventDefault();

            const btn = $(this);

            if (btn.next().hasClass('forConf')) {
                if (btn.next().css('display') == 'none') {
                    btn.addClass('opened');
                } else {
                    btn.removeClass('opened');
                }
            }

            if (U.isMobile() && btn.hasClass('opened')) {
                btn.parent().find('.do-short').remove();
                btn.parent().find('.show-all').removeClass('hidden');
            }

            btn.next().slideToggle();
            btn.toggleClass('opened');

        });

        if (FILTER.is_catalog || FILTER.is_search() || FILTER.is_outlet() || FILTER.change_url_allowed()) {
            if (!FILTER.is_mobile())
                setTimeout(function () {
                    $(window).on('popstate', function (e) {
                        console.log('popstate')
                        let spl = FILTER.was_page.split('/');
                        let spl2 = document.location.pathname.split('/');
                        let was = document.location.href.substr(document.location.origin.length);

                        if (spl[1] == spl2[1] && FILTER.was_page !== was)
                            FILTER.load(1, was);
                        else
                            return true;
                    });
                }, 0);
        }

        $('body').on('click', ".filter .filter-title .cog", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let title = btn.parents('.filter-title');
            let container = btn.parent().parent();

            if (!title.hasClass('opened')) {
                title.next().slideToggle();
                title.toggleClass('opened');
                btn.removeClass('active');
            }

            FILTER.set_option_search(container.data('id'), {
                settings: btn.hasClass('active') ? false : true,
            });

            FILTER.fill_options_search();
        });

        $('body').on('click', ".filter .filter-settings .az, .filter .filter-settings .count", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let container = btn.parent().parent().parent();
            let sort = btn.hasClass('az') ? 'az' : 'count';
            let direction = btn.hasClass('active') ? (btn.hasClass(sort + '_asc') ? 'desc' : 'asc') : btn.data('direction');

            FILTER.set_option_search(container.data('id'), {
                sort: sort,
                direction: direction,
                opened: true,
                settings: true,
                expand: true
            });

            FILTER.fill_options_search();
        });

        $('body').on('click', ".filter .filter-settings .remove", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let input = btn.parent().find('input');
            let container = input.parent().parent().parent();
            input.val('');
            FILTER.set_option_search(container.data('id'), {
                query: '',
                expand: true,
                settings: true,
                opened: true
            });
            FILTER.fill_options_search();
        });

        $('body').on('click', ".filter .filter-settings .eye", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let container = btn.parent().parent().parent();

            FILTER.set_option_search(container.data('id'), {
                hide_unavailable: btn.hasClass('active') ? false : true,
                expand: true,
                settings: true
            });
            FILTER.fill_options_search();
        });

        $('body').on('keyup', ".filter .filter-settings input", function (e) {
            let input = $(this);
            let container = input.parent().parent().parent();
            FILTER.set_option_search(container.data('id'), {
                query: input.val(),
                expand: true,
                settings: true
            });
            FILTER.fill_options_search();
        });

        $('body').on('click', ".catalog .catalog__goods .show-more:not(.link), .promo__page-filter .show-more:not(.link)", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (FILTER.x)
                return;

            FILTER.setpage(FILTER.currentpage + 1);
            FILTER.topposition = $(document).scrollTop();
            let btn = $(this);
            let url = FILTER.make_url();

            btn.addClass('show-more-loading');

            if (FILTER.change_url_allowed()) {
                history.pushState({}, null, url);
                GTM.event('pageview', url);
            }

            FILTER.pagination_started = true;
            btn.find('i').addClass('fa-spin');
            btn.parent().addClass('spin');

            FILTER.postData(
                {string: url},
                '/aj?' + url
            ).then((data) => {
                FILTER.pagination_started = false;
                btn.find('i').removeClass('fa-spin');
                btn.parent().removeClass('spin');

                if (FILTER.is_promotion() && data.template == 'blocks') {
                    $(".looplist").append(data.blocks_result.join(''));
                } else {
                    if (data.goods.length == 0 || data.goods.length < 48)
                        $(".more, .show-more").css('display', 'none');

                    if (typeof data.goods === "object" && data.goods.length > 0)
                        $.each(data.goods, function (index, value) {
                            if (FILTER.previewmode == 'grid') {
                                FILTER.appendProduct(value);
                            } else if (this.previewmode == 'list') {
                                FILTER.appendProductList(value);
                            } else if (this.previewmode == 'pclist') {
                                FILTER.appendPCList(value);
                            }
                        });

                    $(".pagination").remove();
                    $(data.pagination).appendTo(".catalog__goods");
                }

                COMPARSION.update_anchors();
                WISHLIST.update_anchors();

                if (!FILTER.is_promotion() && !FILTER.is_accs())
                    if (!($(".pagination .next.active").length) && FILTER.catalog_id > 0)
                        $(".catalog .catalog__goods .show-more, .promo__page-filter .catalog__goods .show-more").addClass('hidden');

                $(document).scrollTop(FILTER.topposition);

                FILTER.show_more_btn(data);

                GTM.event('impressions');
                return false;
            }).finally(() => {
                btn.removeClass('show-more-loading');
            });
            return false;
        });

        $('body').on('click', ".js-filter__s", function(e){
            e.preventDefault();
            $(".filter__sbtn").toggleClass('filter__sbtn-show');

            if ($(this).hasClass('filter__sback')) {
                FILTER.search_query = '';
                FILTER.load(true);
            } else {
                $(".js-filter__sinput")[0].focus();
            }
        });

        $('body').on('keyup', ".js-filter__sinput", function(e){
            e.preventDefault();

            FILTER.search_query = $(this).val();
            clearTimeout(FILTER.timemoutId);
            FILTER.timemoutId = setTimeout(() => {
                FILTER.load(true);
            }, 1000);
        });

        $('body').on('click', ".js-catalog__pclistswitcher", function(e){
            e.preventDefault();
            let btn = $(this);
            let previewmode = btn.hasClass('catalog__pclistswitcher-active') ? 'grid' : 'pclist';
            localStorage.setItem('makepc_previewmode', previewmode);
            FILTER.setpreviewmode(previewmode);
            btn.toggleClass('catalog__pclistswitcher-active');

        });

        $('body').on('click', ".js-loopw__details", function(e){
            e.preventDefault();
            let btn = $(this);
            btn.toggleClass('typical-chevron-up');
            let loopw = btn.parents('.loopw');
            let details = loopw.next();

            if (btn.hasClass('typical-chevron-up')) {
                details.removeClass('hidden');
                $(".loopw").not(loopw).addClass('loopw-semi');
                $(".loopw__details").not(details).addClass('loopw-semi');
            } else {
                details.addClass('hidden');
                $(".loopw").removeClass('loopw-semi');
                $(".loopw__details").removeClass('loopw-semi');
            }
        });

        // search?
        if ($(".js-filter__hiddenoption").length > 0) {
            let el = $(".js-filter__hiddenoption .filter-content >.filter__item:eq(0)");

            if (!el.hasClass('active')) {
                el.removeClass('active').trigger('click');
            }

        }

    });
}
